<app-entity-name-number-record
  class="company-name-acn"
  [name]="name"
  [numberFormatted]="acn | acn"
  (handleClick)="onOpenCompanyProfile($event)"
></app-entity-name-number-record>
